<template>
  <div class="text-nash-midnightBlue700">
    <TDialog
      :size="DialogSize.MD"
      title=" "
      title-icon="sparkles"
      :visible="isOpen"
      :blocking="false"
      @close="close"
    >
      <template #titleActions>
        <div @mousedown.stop="swallowEvent">
          <TTabMenu
            :items="items"
            :current-tab-index="activeTabIndex"
            @tab-change="onTabChange"
          />
        </div>
      </template>

      <div>
        <AskSOPModal
          v-show="activeTab === LLM_TAB.ASK_THYME_BOX"
          :show-dev-tools="showDevTools"
        />
        <AskAProfile
          v-show="activeTab === LLM_TAB.ASK_A_PROFILE && showAskAProfile"
          :patient-person="validatedPerson"
          :show-dev-tools="showDevTools"
        />
        <ConnectArticles
          v-show="activeTab === LLM_TAB.CONNECT_ARTICLES"
          :external-thymebox-patient-id="externalThymeboxPatientId"
        />
      </div>
    </TDialog>
  </div>
</template>

<script lang="ts">
import TDialog from '@nashville/dialog/TDialog.vue'
import TTabMenu from '@nashville/tabmenu/TTabMenu.vue'
import { defineComponent } from 'vue'
import ConnectArticles from '@/tokens/connectArticles/ConnectArticles.vue'
import AskAProfile from '@/tokens/llm/AskAProfile/AskAProfile.vue'
import AskSOPModal from '@/tokens/llm/AskSOPModal/AskSOPModal.vue'
import setup from './controller'
import { ASK_LLMS_MODAL_PROPS } from './types'

export default defineComponent({
  name: 'AskLlmsModal',
  components: { TDialog, AskSOPModal, AskAProfile, TTabMenu, ConnectArticles },
  props: ASK_LLMS_MODAL_PROPS,
  emits: ['close'],
  setup,
})
</script>
